const messages = {
  en: {
    image: 'Open Image'
  },
  'es-ud': {
    image: 'Abrir Imagen'
  },
  es: {
    image: 'Abrir Imagen'
  }
}

export default messages



// WEBPACK FOOTER //
// ./src/components/TutorialStep/messages.js